// A rail link's address: its route plus the parameters the entry keeps
// (`keep`) that the current address holds.

/** `to` with the parameters in `keep` the current address holds. */
export function carried(to: string, search: string, keep: readonly string[] | undefined): string {
  if (!keep?.length) return to;
  const current = new URLSearchParams(search);
  const params = new URLSearchParams();
  for (const k of keep) {
    const v = current.get(k);
    if (v) params.set(k, v);
  }
  const query = params.toString();
  return query ? `${to}${to.includes('?') ? '&' : '?'}${query}` : to;
}

/**
 * Whether following a rail link to `to` replaces the current history entry:
 * a link to the screen already shown (e.g. Game stats back to its latest
 * game) resets that screen rather than stacking another entry.
 */
export function replacesEntry(pathname: string, to: string): boolean {
  const path = to.split('?')[0];
  return pathname === path;
}
